import { ICartItem_Product } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { useState } from "react";
import EditNoteModal from "../manage-cart-item/EditNoteModal";
import SvgEditCartItem from "./SvgEditCartItem";
import SvgEditNote from "./SvgEditNote";
import useProductPopup from "@/hooks/useProductPopup";

interface Props {
  small: boolean;
  cartItem: ICartItem_Product;
  setNote: (note: string) => void;
}

const CartItemIcons: React.FC<Props> = ({ small, cartItem, setNote }) => {
  const { handleOpenPopup } = useProductPopup();


  const slug = cartItem?.inner_slug;
  const [showEditNote, setShowEditNote] = useState(false);
  const InLine = small ? "div" : "span";
  return (
    <div>
      {cartItem?.can_edit && (
        <SvgEditCartItem
          onClick={() =>
            handleOpenPopup({ productID: slug!, cartItemID: cartItem.id, isConfigurable: true })
          }
          small={small}
        />
      )}
      <InLine style={small ? {} : { marginInlineStart: 8 }}>
        <SvgEditNote
          onClick={() => setShowEditNote(true)}
          small={small}
          active={!!cartItem.note}
        />
      </InLine>
      {showEditNote && (
        <EditNoteModal
          show={showEditNote}
          setShow={setShowEditNote}
          note={cartItem?.note}
          setNote={setNote}
        />
      )}
    </div>
  );
};

export default CartItemIcons;
